require('../styles.css');
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/icons/monochrome/IconThumbUp.tsx
var IconThumbUp_exports = {};
__export(IconThumbUp_exports, {
  default: () => IconThumbUp_default
});
module.exports = __toCommonJS(IconThumbUp_exports);

// src/assets/monochrome/thumbUp.svg
var import_jsx_runtime = require("react/jsx-runtime");
var SvgThumbUp = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.49961 1.1001H8.96204L5.46204 7.6001H4.49961C3.50791 7.6001 2.63135 7.91475 2.00406 8.56049C1.38093 9.20195 1.09961 10.0714 1.09961 11.0001V15.0001C1.09961 15.9918 1.41426 16.8684 2.06 17.4956C2.70146 18.1188 3.57092 18.4001 4.49961 18.4001H14.9996C15.9982 18.4001 16.8134 18.0827 17.4058 17.5371C17.9875 17.0013 18.2943 16.3009 18.3906 15.6274C18.5566 14.4651 18.9871 11.6516 19.3821 9.6766C19.5813 8.68076 19.4724 7.73403 18.8723 7.03287C18.2807 6.34176 17.3907 6.1001 16.4996 6.1001H12.8996V4.0001C12.8996 2.81368 12.2502 2.04582 11.5113 1.62022C10.8172 1.2204 10.0254 1.1001 9.49961 1.1001ZM5.09961 9.4001H4.49961C3.89131 9.4001 3.51787 9.58545 3.29516 9.8147C3.06829 10.0482 2.89961 10.4288 2.89961 11.0001V15.0001C2.89961 15.6084 3.08496 15.9818 3.31422 16.2045C3.54776 16.4314 3.9283 16.6001 4.49961 16.6001H5.09961V9.4001ZM6.89961 16.6001H14.9996C15.601 16.6001 15.9644 16.4175 16.1863 16.2131C16.4189 15.9989 16.562 15.6993 16.6087 15.3728C16.7759 14.2018 17.2121 11.3486 17.6171 9.32359C17.755 8.63409 17.6139 8.33083 17.5048 8.20332C17.387 8.06576 17.1085 7.9001 16.4996 7.9001H11.0996V4.0001C11.0996 3.58651 10.9157 3.35437 10.6129 3.17998C10.4288 3.07396 10.2137 3.00173 10.0064 2.95724L6.89961 8.727V16.6001Z", fill: "#676F7E" }) });
var thumbUp_default = SvgThumbUp;

// src/Wrappers/helpers.ts
var getIconBaseCssVariables = ({
  size,
  rotate,
  transitionDuration
}) => {
  return {
    "--icon-size": size ? `${size}px` : "100%",
    "--icon-rotate": rotate ? `${rotate}deg` : "0deg",
    // Browser cannot handle multiple transitions on the same property if another variable (e.g. --transition-duration)
    // is defined on another element.
    "--icon-transition-fill": transitionDuration ? `fill ${transitionDuration} ease` : "none",
    "--icon-transition-transform": transitionDuration ? `transform ${transitionDuration} ease` : "none"
  };
};
var getIconColoringCssVariables = ({
  state,
  color,
  activeColor
}) => {
  return {
    "--icon-color": state === "active" ? activeColor : color,
    "--icon-active-color": state === "disabled" || !activeColor ? color : activeColor
  };
};

// src/Wrappers/IconWrapper.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var getWrapperStyles = (props) => ({
  ...getIconBaseCssVariables(props),
  ...getIconColoringCssVariables(props)
});
var IconWrapper = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "div",
    {
      className: "ui-icon-size-wrapper ui-icon-coloring-wrapper",
      style: getWrapperStyles(props),
      children: props.children
    }
  );
};

// src/icons/monochrome/IconThumbUp.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var IconThumbUp = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(IconWrapper, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(thumbUp_default, {}) });
};
IconThumbUp.displayName = "IconThumbUp";
var IconThumbUp_default = IconThumbUp;
